import React from 'react';
import { useTheme } from '@mui/material';
import useStyles from './DrawerMenu.styles.ts';
import Box from '@mui/material/Box';
import { ButtonTwo, Typo } from 'components/primitive';
import { CircleArrowRight, CircleCheck } from 'lucide-react';
import type { JPDAActionType, JPDASettingType } from './useJPDAWorkflow.tsx';

export type JPDASubMenuProps = {
  counts: { paStarted: number; paInactive: number; iaStarted: number; iaInactive: number };
  onAction: (settingType: JPDASettingType, actionType: JPDAActionType) => void;
};

/** The JPDA Start / End buttons for PA and IA; the modal they open lives in useJPDAWorkflow. */
const JPDASubMenu: React.FC<JPDASubMenuProps> = ({ counts, onAction }) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const completeActionIcon = <CircleCheck size={12} />;
  const startActionIcon = <CircleArrowRight size={12} />;

  const rows: { label: string; type: JPDASettingType; started: number; inactive: number }[] = [
    {
      label: 'Public Assistance',
      type: 'PA',
      started: counts.paStarted,
      inactive: counts.paInactive,
    },
    {
      label: 'Individual Assistance',
      type: 'IA',
      started: counts.iaStarted,
      inactive: counts.iaInactive,
    },
  ];

  return (
    <Box sx={classes.sectionSubMenu.container}>
      <Box sx={classes.sectionSubMenu.content}>
        {rows.map((row) => (
          <Box key={row.type} sx={classes.sectionSubMenu.row}>
            <Typo color={theme.palette.text.secondary} fontSize={'12px'} fontWeight={500}>
              {row.label}
            </Typo>
            <Box sx={classes.sectionSubMenu.btnGrp}>
              <ButtonTwo
                alternate
                startIcon={<span>{row.inactive}</span>}
                leftText={<span>JPDA</span>}
                rightText={<span>Start</span>}
                endIcon={startActionIcon}
                onClick={() => onAction(row.type, 'Begin')}
              />
              <ButtonTwo
                alternate={row.started === 0}
                startIcon={<span>{row.started}</span>}
                leftText={<span>JPDA</span>}
                rightText={<span>End</span>}
                endIcon={completeActionIcon}
                onClick={() => onAction(row.type, 'Complete')}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default JPDASubMenu;
